<template>
  <div class='h100-40'>
    <ImportTableMenu :isImport='isImport' @methodEnum='methodEnum'></ImportTableMenu>
    <div class='h-track-flexContent h-track-flexRow'>
      <div id='trackTable' class='h100vh-180 h-track-flexItem'>
        <ImportTable ref='importTable' :isImport='isImport' @rowJson='rowJsonFunc'></ImportTable>
      </div>
      <div class='h100vh-180 h-track-w35rem h-track-borTop'>
        <ImportJsonTree ref='jsonTree'></ImportJsonTree>
      </div>
    </div>
  </div>
</template>
<script>
import ImportTableMenu from './ImportTableMenu';
import ImportTable from './ImportTable';
import ImportJsonTree from './ImportJsonTree';

export default {
  name: 'ImportTrackList',
  props: {
    isImport: { type: Boolean, default: false },
  },
  components: {
    ImportTableMenu,
    ImportTable,
    ImportJsonTree
  },
  data() {
    return {
      panelContent() {
        return {
          template: ImportTable
        };
      }
    };
  },
  methods: {
    methodEnum(opcode) {
      switch (opcode) {
        case 'import':
          this.$refs.importTable.importTrackFunc();
          break;
        case 'export':
          this.$refs.importTable.exportTrackFunc();
          break;
        case 'search':
          this.$refs.importTable.searchTask();
          break;
        case 'active':
          this.$refs.importTable.activeTrackPage();
          break;
        case 'hangup':
          this.$refs.importTable.hangupTrackPage();
          break;
        case 'finish':
          this.$refs.importTable.finishTrackPage();
          break;
        default:
      }
    },
    rowJsonFunc(data) {
      this.$refs.jsonTree.loadData(data);
    }
  },
  beforeMount() {
    const trackNowTab = JSON.parse(localStorage.getItem('trackNowTab'));
    if (trackNowTab.type === 'Import') {
      this.isImport = true;
    }
  }
};
</script>